import axios from "axios"
import { toast } from "react-toastify"

export const LoginFunction = async (email, password, navigate, setLoginLoading) => {
    try {
        const response = await axios.post("https://tpsmit-backend.onrender.com/user/login", { email: email, password })
        if (response.data.success) {
            localStorage.setItem("token", response.data.token)
            navigate("/home")
            toast.success(response.data.message)
        }
    } catch (err) {
        toast.error(err.response.data.message)
    }
}
export const sendOTPHandler = async (email, setotpGenerated) => {
    try {
        const response = await axios.post("https://tpsmit-backend.onrender.com/student/register/otp/signup/mail/new", { email: email.toLowerCase() })
        setotpGenerated(true)
        toast.success(response.data.message)
    } catch (err) {
        setotpGenerated(false)
        toast.error(err.response.data.message)
    }
}
export const resendOTPHandler = async (email, setotpGenerated) => {
    try {
        const response = await axios.post("https://tpsmit-backend.onrender.com/student/register/otp/signup/mail/resend", { email: email.toLowerCase() })
        setotpGenerated(true)
        toast.success(response.data.message)
    } catch (err) {
        setotpGenerated(false)
        toast.error(err.response.data.message)
    }
}
export const signupHandler = async (email, otp, password, navigate,regid) => {
    try {
        const response = await axios.post("https://tpsmit-backend.onrender.com/student/register/otp/signup/mail/verify", { email: email.toLowerCase(), otp, password,regid })
        toast.success(response.data.message)
        localStorage.setItem("token", response.data.token)
        navigate(`/student/profile/edit`)
    } catch (err) {
        toast.error(err.response.data.message)
    }
}